import { render, staticRenderFns } from "./Vorstand.vue?vue&type=template&id=44c6c9ae&scoped=true&"
import script from "./Vorstand.vue?vue&type=script&lang=js&"
export * from "./Vorstand.vue?vue&type=script&lang=js&"
import style0 from "./Vorstand.vue?vue&type=style&index=0&id=44c6c9ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c6c9ae",
  null
  
)

export default component.exports